import { Component, OnInit, Input } from "@angular/core";
import { TopSenders } from "../../dashboard.model";
import { DashboardService } from "../../dashboard.service";
import { ChartType, ChartData } from "chart.js";
import { Breakpoints, BreakpointObserver } from "@angular/cdk/layout";
import { map } from "rxjs/operators";

@Component({
    selector: "chart-top-senders",
    templateUrl: "./top-senders.component.html",
    styleUrls: ["./top-senders.component.css"],
    standalone: false
})
export class TopSendersComponent implements OnInit {
  @Input("topSenderError")
  set topSenderError(value: string) {
    this.error = value;
  }
  get topSenderError(): string {
    return this.error;
  }

  @Input("topSenderData")
  set topSenderData(value: TopSenders[]) {
    this.data = value;
    this.chartData();
  }
  get topSenderData(): TopSenders[] {
    return this.data;
  }

  @Input("isLoading") isLoading: boolean = false;

  layoutChanges = this.breakpointObserver.observe([
    Breakpoints.Handset,
    Breakpoints.Small,
    Breakpoints.XSmall,
  ]);
  public chartHeight = 500;

  public doughnutChartType: ChartType = 'doughnut';
  public doughnutChartLabels: string[] = [];
  public doughnutChartData: ChartData<'doughnut'>;

  public chartColors = ["#16B65A", "#4B667B", "#FF0004", "#293A01", "#80B29C"];  
  public chartOptions = {
    type: 'doughnut',
    title: {
      text: "",
      display: false,
    },
    maintainAspectRatio: false,
    responsive: true,
  };

  data: TopSenders[];
  error: string;

  constructor(
    private api: DashboardService,
    private breakpointObserver: BreakpointObserver
  ) {}

  ngOnInit() {
    this.layoutChanges.subscribe((result) => {
      if (result.matches) {
        this.chartHeight = 250;
      } else {
        this.chartHeight = 500;
      }
    });
  }

  async chartData() {
    if (!this.data) {
      return;
    }

    this.doughnutChartLabels = this.data.map(row => row.name);
    this.doughnutChartData = {            
      labels: this.doughnutChartLabels,
      datasets: [ 
        { 
          data: this.data.map(row => row.salesmails),
          backgroundColor: this.chartColors
        } 
      ]
    };

    // this.data.forEach((element) => {
    //   this.doughnutChartLabels.push(element.name);
    //   this.doughnutChartData.push(element.salesmails);
    // });
  }

  public chartClicked({
    event,
    active,
  }: {
    event: MouseEvent;
    active: {}[];
  }): void {
    //console.log(event, active);
  }

  public chartHovered({
    event,
    active,
  }: {
    event: MouseEvent;
    active: {}[];
  }): void {
    //console.log(event, active);
  }
}
